import { choose } from '../../utils/platform';
import ServiceFormDesktop from './ServiceForm.desktop';
import ServiceFormMobile from './ServiceForm.mobile';

// Platform chooser: phone (APK or narrow browser) gets the full-screen variant.
export default choose(ServiceFormDesktop, ServiceFormMobile);
